import classNames from "classnames";
import * as React from "react";
import { SubmitHandler, Field } from "redux-form";
import Accordion from "~/components/accordion/accordion";
import AccordionContent from "~/components/accordion/accordion-content/accordion-content";
import AccordionHeader from "~/components/accordion/accordion-header/accordion-header";
import AccordionItem from "~/components/accordion/accordion-item/accordion-item";
import { useAccordion } from "~/components/accordion/useAccordion";
import InputCheckbox from "~/components/input-checkbox/input-checkbox";
import { IFacetFormData, IFacetFormAllProps, IFacetGroup } from "../facet-form/facet-form";

interface IFacetGroupProps extends IFacetGroup {
    index: number;
    seeMoreLabel?: string;
    seeLessLabel?: string;
    handleSubmit: SubmitHandler<IFacetFormData, IFacetFormAllProps, string>;
}

const FacetGroup: React.FC<IFacetGroupProps> = ({
    facets,
    label,
    index,
    handleSubmit,
    seeLessLabel,
    seeMoreLabel
}) => {
    const [activeIndex, setActiveIndex] = useAccordion(index);
    const isActive = activeIndex === index;
    const [isOverflowHidden, setIsOverflowHidden] = React.useState(true);
    const hasOverflow = facets.length > 5;
    const baseClass = "facet-group";
    const classes = classNames(baseClass, {
        [`${baseClass}--overflowHidden`]: isOverflowHidden
    });

    return (
        <Accordion className={classes}>
            <AccordionItem
                isActive={isActive}
                renderHeader={
                    <AccordionHeader isActive={isActive} onClick={() => setActiveIndex(index)}>
                        <h4 className="facet-group__header">{label}</h4>
                    </AccordionHeader>
                }
                renderContent={
                    <AccordionContent>
                        {facets.map(facet => {
                            return (
                                <div className="facet-group__facet" key={facet.id}>
                                    <Field
                                        component={InputCheckbox}
                                        label={`
                                            <span>${facet.label}</span>
                                            <span class="facet-group__facet-count">(${facet.count})</span>
                                        `}
                                        name={facet.id}
                                        fieldName={facet.id}
                                        onChange={handleSubmit}
                                    />
                                </div>
                            );
                        })}
                    </AccordionContent>
                }
            />
            {hasOverflow && isActive && (
                <button
                    className={`${baseClass}__toggle-overflow-btn reset-button`}
                    onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                        event.preventDefault();
                        setIsOverflowHidden(!isOverflowHidden);
                    }}
                >
                    {isOverflowHidden ? seeMoreLabel : seeLessLabel}
                </button>
            )}
        </Accordion>
    );
};

export default FacetGroup;
